export interface OrderSettings {
  dataList: any[];

  pagination: {
    pageSize: number;
    currentPage: number;
  };

  total: number;
  showLoadMoreButton: boolean;
}
export default {
  pagination: {
    pageSize: 10,
    currentPage: 1,
  },

  showLoadMoreButton: true,
} as OrderSettings;

export const spaceName = 'caPreviousOrder';
